import React, { useState } from "react";
import { gallery } from "../mock";
import { X } from "lucide-react";

export default function Gallery() {
  const [open, setOpen] = useState(null);
  return (
    <section className="bg-cream bg-dotted py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-[11px] tracking-[0.3em] text-orange-600 font-semibold uppercase">Showcase</p>
          <h2 className="font-display text-3xl md:text-5xl font-bold mt-3 uppercase">Our Gallery</h2>
          <span className="block w-24 h-[3px] bg-orange-500 mx-auto mt-4" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {gallery.map((src, i) => (
            <button key={i} onClick={() => setOpen(src)} className="group relative overflow-hidden rounded-2xl bg-white border border-orange-100 aspect-[4/3] shadow-sm hover:shadow-xl transition-shadow">
              <img src={src} alt={`Gallery ${i + 1}`} className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-500" />
              <span className="absolute inset-0 bg-orange-500/0 group-hover:bg-orange-500/10 transition-colors" />
            </button>
          ))}
        </div>
      </div>
      {open && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-6" onClick={() => setOpen(null)}>
          <button className="absolute top-5 right-5 w-10 h-10 rounded-full bg-white/10 text-white flex items-center justify-center hover:bg-orange-500" onClick={() => setOpen(null)}>
            <X />
          </button>
          <img src={open} alt="Preview" className="max-w-[90vw] max-h-[85vh] object-contain rounded-xl" />
        </div>
      )}
    </section>
  );
}
